"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @emails oncall+internationalization
 * 
 * @format
 */

/* eslint-disable fb-www/flow-exact-by-default-object-types */
// TODO T61557741: Move these types to fbt.js when it's flow strict

/**
 * This is the main input payload to the fbt._(...) runtime call.
 *
 * - For simple fbt calls without interpolation (fbt.param) or multiplexing (fbt.plural,
 *   fbt.enum, viewer context variation, etc), this is a simple vanilla string.
 * - Otherwise this is a table whose keys correspond to the associated runtime
 *   parameters passed to fbt._, named `args`.
 *
 *  See the docblock for fbt._ for an example of the nested table and its behavior
 */

/**
 * In ReactNative and OSS, there is a per-fbt-callsite hash (defaults to Jenkins
 * hash) for looking up fbt translation payloads per callsite.  There is also an
 * enum hash key used to access the pre-calculated table given a set of
 * enumeration values.
 */
// TODO: T61015960 - getFb[st]Result should return types that are locked down
var FbtEnv = require("./FbtEnv");

var FbtHooksImpl = require("./FbtHooksImpl");

module.exports = FbtHooksImpl;
FbtEnv.setupOnce();